const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** ¿Parece un identificador técnico (UUID) en vez de un nombre? */
export function looksLikeId(v: string | undefined | null): boolean {
  return !!v && UUID_RE.test(v.trim());
}

/**
 * Resuelve un id a un nombre legible (#58). Orden: `hint` (nombre que ya trae el
 * registro, si no es un id) → `names` (lista ya cargada) → fallback.
 * Nunca devuelve un UUID crudo: si no hay nombre, muestra `#` + los 8 primeros caracteres.
 */
export function resolveEntityName(
  id: string | undefined | null,
  names: ReadonlyMap<string, string>,
  hint?: string | null,
): string {
  if (!id) return hint && !looksLikeId(hint) ? hint : '—';
  if (hint && hint.trim() && !looksLikeId(hint)) return hint;
  const fromMap = names.get(id);
  if (fromMap) return fromMap;
  return looksLikeId(id) ? `#${id.slice(0, 8)}` : id;
}
